import type { ValidationItems } from '@kanda-libs/ks-component-ts';
import {
  CLASS_NAMES as BASE_CLASS_NAME,
  type QuoteClassNames,
} from '../../constants';

interface CalculatorClassNames extends QuoteClassNames {
  card: string;
  container: string;
  box: string;
  lineHeading: string;
  lineSubheading: string;
  lineTotal: string;
  separator: string;
}

export const CLASS_NAMES: CalculatorClassNames = {
  ...BASE_CLASS_NAME,
  card: 'flex flex-col rounded border border-neutral-200 px-6 py-8 shadow-card',
  container: 'flex flex-row flex-1 first:mb-5',
  box: 'flex flex-col flex-1 first:min-w-40 md:first:min-w-52 first:mr-4 lg:first:mr-18',
  lineHeading: 'text-14-22-em text-neutral-700 mb-1',
  lineSubheading: 'text-12-18 md:text-13-14 text-neutral-700',
  lineTotal: 'text-16-20 text-neutral-900 pl-2',
  separator: 'my-6 border-b border-neutral-300',
};

export const CREDIT_AMOUNT_FIELD_NAME = 'credit.amount';

export const DEPOSIT_AMOUNT_FIELD_NAME = 'deposit.amount';

export const BASE_VALIDATION: ValidationItems = {
  required: { value: true, message: 'Credit amount is required.' },
  min: { value: 0, message: 'Credit amount must be great than 0' },
  max: {
    value: 2147483647,
    message: 'Credit amount must be smaller than 2.147483647e+09',
  },
};
